export default {
  // baseURL: 'http://ticket-api.gdhttech.com',
  version: '1.0.1'
}